/* ===========================
IMPORTS
=========================== */
import React from 'react';
import PropTypes from 'prop-types';
// IMPORT - ELEMENTS
import Loader from '../Elements/Loader';
// IMPORT - Helpers
import Helpers from '../../Helpers';

/* ===========================
CLASS
=========================== */
class ModalBatchCriticalUpdate extends React.Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
   * Main constructor of Component
   * @param {object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      override: null,
      errors: null,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  /**
  * componentDidMount
  */
  componentDidMount() {
    this.props.updateLoadingModal(false);
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   * @param {Event} event
   */
  handleSubmit(event) {
    this.setState({
      errors: null,
    });

    this.props.handleSubmit(true);

    const payload = {
      players: this.props.data.map((item) => ({
        device_id: item,
        maintenance_schedule_override: this.state.override,
      })),
    };

    if (this.props.data && this.props.data.length > 0
      && this.state.override !== null && this.state.override !== undefined) {
      Helpers.httpRequest(
        `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/players`,
        'put',
        JSON.stringify(payload),
        // callback
        () => {
          this.props.handleSubmitSuccess();
          this.props.handleSubmit(false);
        },
        // failback
        (error) => {
          this.setState({
            errors: error,
          }, () => {
            this.props.handleSubmit(false);
          });
        },
      );
    } else {
      this.setState({
        errors: {
          message: 'Please choose an override state.',
        },
      }, () => {
        this.props.handleSubmit(false);
      });
    }

    event.preventDefault();
  }

  /**
   * @param {Event} event
   */
  handleChange(event) {
    this.setState({
      override: (event.target.value === 'on'),
    });
  }

  /* ===========================
  RENDER
  =========================== */
  render() {
    return (
      <div>
        {(!this.props.loading)
          ? (
            <form id={this.props.id} onSubmit={this.handleSubmit}>
              <div className="form-group">
                <div className="alert alert-warning">
                  {this.props.data.length}
                  {' '}
                  item
                  {(this.props.data.length !== 1) ? 's' : null}
                  {' '}
                  selected
                </div>
              </div>
              <div className="form-group">
                <div className="form-check">
                  <input disabled={this.props.submitted} onChange={this.handleChange} className="form-check-input" type="radio" name="maintenance_schedule_override" value="on" />
                  <label className="form-check-label" htmlFor="recurrence-immediate">
                    On
                  </label>
                </div>
                <div className="form-check">
                  <input disabled={this.props.submitted} onChange={this.handleChange} className="form-check-input" type="radio" name="maintenance_schedule_override" value="off" />
                  <label className="form-check-label" htmlFor="recurrence-immediate">
                    Off
                  </label>
                </div>
              </div>

              {(this.state.errors && Object.keys(this.state.errors).length > 0)
                ? (
                  <div className="form-group">
                    <div className="alert alert-danger">
                      <ul>
                        {(Object.keys(this.state.errors).map((item) => (
                          <li key={item}>
                            <strong>{item}</strong>
                            {' '}
                            -
                            {' '}
                            {this.state.errors[item]}
                          </li>
                        )))}
                      </ul>
                    </div>
                  </div>
                )
                : null}

              {(this.props.submitted)
                ? (<Loader />)
                : null}
              <button type="submit" aria-label="submit" style={{ display: 'none' }} disabled={this.props.submitted} />
            </form>
          )
          : null}
      </div>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
ModalBatchCriticalUpdate.propTypes = {
  id: PropTypes.string,
  data: PropTypes.object,
  loading: PropTypes.bool,
  submitted: PropTypes.bool,
  updateLoadingModal: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleSubmitSuccess: PropTypes.func,
};

/* ===========================
EXPORT
=========================== */
export default ModalBatchCriticalUpdate;
